import styled from "styled-components";
import { Link } from "react-router-dom";
import {
  DataGridHeading,
  Modal,
  DataGrid,
  DisplaySmall,
  color,
  spacing,
} from "@conserveit/blocks";

export const GoToEquip = styled(Link)`
  color: inherit;
  text-decoration: none;
  display: contents;
`;
export const StyleDataGridHeading = styled(DataGridHeading)`
  &:focus {
    outline: none;
  }
`;

export const StyledModal = styled(Modal)`
  overflow: hidden;
  justify-content: center;
  /** ! HACK: Need to update the modal props in blocks to accept width/height props */
  section {
    min-height: 72px !important;
    width: 700px !important;
  }
`;

export const StyledDataGrid = styled(DataGrid)`
  width: 100%;
`;
export const LoadingWrapper = styled.div`
  margin: 40px 0;
  width: 100%;
`;
export const SubduedDisplaySmall = styled(DisplaySmall)`
  color: ${color.theme.typography.subdued};
`;

export const ModalTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const ErrorWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: ${spacing.default};
`;
